import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'meu-modal-user-company-info',
  templateUrl: './modal-user-company-info.component.html',
  styleUrls: ['./modal-user-company-info.component.scss'],
})
export class ModalUserCompanyInfoComponent implements OnInit {
  userId = null;
  isAdminPage = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data) {}
  ngOnInit() {
    this.userId = this.data.userId;
    this.isAdminPage = this.data.isAdminPage;
  }
}
